import { requiredNonEmptyString } from '../../../utils/validate-payload.js';
export const facetIdDefinition = requiredNonEmptyString;
